import { SET_FIELD_LOADING } from 'root/src/client/logic/form/actionIds'

export default (fieldId, loading) => ({
	type: SET_FIELD_LOADING,
	payload: {
		fieldId,
		loading,
	},
})
